import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IVideosRequest } from '@/Module/Workspace/Model/ApiModel';
import type { IVideoViewed } from '@/Module/Workspace/Model/DataModel';
import { WorkspaceService } from '@/Module/Workspace/Service';

export const getMostViewedVideosAction = createAsyncThunk<IVideoViewed[], Partial<IVideosRequest> | undefined>(
  'workspace/mostViewedVideos',
  async (query, { signal }) => {
    return WorkspaceService.getMostlyViewed({ pageNo: 0, pageCount: 4, SortOrder: 'ViewCount DESC', ...query }, signal).then(
      ({ data: { data } }) => data,
    );
  },
);
